import { COMPLETED, CURRENT, INCOMPLETE } from '../literals/literals';

const INCORRECT_SEQUENCE_WARNING = 'Warning: The provided steps are not in a logical sequence.';

const isInvalidIncomplete = (previousStepType, step) =>
	previousStepType === INCOMPLETE && step.step === CURRENT;

const isInvalidComplete = (previousStepType, step) =>
	previousStepType === COMPLETED && step.step === INCOMPLETE;

const hasIncorrectlySequencedSteps = steps => {
	let previousStepType = null;

	for (let i = 0; i < steps.length; i++) {
		const step = steps[i];

		if (isInvalidIncomplete(previousStepType, step)) {
			return true;
		} else if (isInvalidComplete(previousStepType, step)) {
			return true;
		}

		previousStepType = step.step;
	}

	return false;
};

export const checkStepSequence = steps => {
	if (hasIncorrectlySequencedSteps(steps)) {
		console.warn(INCORRECT_SEQUENCE_WARNING); // eslint-disable-line no-console
	}
};

export const getStepProgress = steps => {
	const stepsComplete = steps.reduce((count, step) => {
		if (step.step === COMPLETED || step.step === CURRENT) {
			return count + 1;
		}

		return count;
	}, 0);

	return Math.round((stepsComplete / steps.length) * 100);
};
